/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLeadInfoRequestRace
 */
export interface CreateLeadInfoRequestRace {
    /**
     * 
     * @type {string}
     * @memberof CreateLeadInfoRequestRace
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadInfoRequestRace
     */
    name?: string;
}

/**
 * Check if a given object implements the CreateLeadInfoRequestRace interface.
 */
export function instanceOfCreateLeadInfoRequestRace(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateLeadInfoRequestRaceFromJSON(json: any): CreateLeadInfoRequestRace {
    return CreateLeadInfoRequestRaceFromJSONTyped(json, false);
}

export function CreateLeadInfoRequestRaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadInfoRequestRace {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function CreateLeadInfoRequestRaceToJSON(value?: CreateLeadInfoRequestRace | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

